<template>
    <v-flex xs6>
        <v-flex class="meeting-tools__links"
                data-qe-id="form_open_dialog_btn"
                @click="openMyMeetingsDialog">
            <i class="fas fa-calendar-alt"></i>
            <v-flex tag="strong">{{'My Meetings'}}</v-flex>
        </v-flex>
        <v-dialog
            persistent
            v-model="myMeetingsDialog"
            scrollable
            content-class="small">

            <v-card v-if="myMeetingsDialog" class="meetings-popup">
                <v-flex>
                    <v-card-title>My Meetings</v-card-title>
                    <v-btn
                        flat
                        icon
                        @click="closeAllDialogs"
                        data-qe-id="close_dialog_btn"
                        id="close_meeting_unitTest"
                        class="close-btn">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-flex>
                <v-card-text class="inner-scrollbar">
                    <v-flex v-for="(meeting,i) in forumMeetings" :key="i">
                        <v-flex class="date"><i class="fas fa-calendar-alt"></i>Tuesday 11, Dec 2018</v-flex>
                        <v-flex class="desc">
                            <v-flex tag="strong" :data-qe-id="`forum-meeting_${i}_agenda`">{{meeting.agenda}}</v-flex>
                            <v-flex tag="span"><i class="fas fa-clock"></i> 06:00 PM - 06:30 PM CST</v-flex>
                            <v-flex tag="small" :data-qe-id="`forum-meeting_${i}_location`">
                                <i class="fas fa-map-marker-alt"></i>
                                {{meeting.location}}
                            </v-flex>
                            <v-flex class="more-info" v-if="meeting.type === 'Retreat'">
                                <i class="fas fa-plane"></i>
                                <v-flex tag="small">Retreat</v-flex>
                            </v-flex>
                            <v-flex class="more-info" v-if="meeting.type === 'standard'">
                                <i class="fas fa-plane"></i>
                                <v-flex tag="small">Retreat</v-flex>
                            </v-flex>
                            <v-flex class="desc__actions">
                                <em> <i class="fas fa-share" :data-qe-id="`forum-meeting_${i}_share`"></i> Share</em>
                                <em><i class="fas fa-times-circle" :data-qe-id="`forum-meeting_${i}_cancel`"></i> Cancel</em>
                            </v-flex>
                        </v-flex>
                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-layout row wrap pa-3>
                        <v-flex xs6>
                            <v-btn outline class="primary_btn transparent">Archive</v-btn>
                        </v-flex>
                        <v-flex xs6 text-xs-right>
                            <v-btn class="primary_btn" id="create_meeting_unitTest"
                                   data-qe-id="forum-meeting_create-meeting_btn"
                                   @click="openCreateNewMeetingDialog">Create Meeting</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            v-model="createNewMeetingDialog"
            scrollable
            content-class="medium">
            <v-card class="meetings-popup">
                <v-flex>
                    <v-card-title>Create New Meeting</v-card-title>
                    <v-btn
                        flat
                        icon
                        data-qe-id="open_meeting_dialog_btn"
                        @click="openMyMeetingsDialog()"
                        class="close-btn">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-flex>
                <v-card-text class="inner-scrollbar">
                    <v-flex class="create-meeting">
                        <v-layout row wrap class="create-meeting__row">
                            <v-flex xs3>
                                <v-flex tag="label"><i class="fas fa-check"></i> Select Forum</v-flex>
                            </v-flex>
                            <v-flex xs5>
                                <v-select
                                    solo
                                    label="Select Forum"
                                    data-qe-id="forum_select_dropdown"
                                    item-text="name"
                                    v-model="newMeeting.selectedForum"
                                    :items="forumsList">
                                </v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="create-meeting__row">
                            <v-flex xs3>
                                <v-flex tag="label"><i class="far fa-handshake"></i> Meeting Type</v-flex>
                            </v-flex>
                            <v-flex xs9>
                                <v-flex :class="isActive ? 'create-meeting__btn' : 'create-meeting__bg-active'"
                                        data-qe-id="forum-standard_link"
                                        @click="isSActive=true">
                                    <i class="far fa-handshake"></i>
                                    <v-flex tag="strong">STANDARD OR VIRTUAL</v-flex>
                                </v-flex>
                                <v-flex :class="isActive ? 'create-meeting__btn' : 'create-meeting__bg-active'"
                                        data-qe-id="forum-retreat_link"
                                        @click="isRActive=true">
                                    <i class="fas fa-plane"></i>
                                    <v-flex tag="strong">RETREAT</v-flex>
                                </v-flex>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap class="create-meeting__row">
                            <v-flex xs3>
                                <v-flex tag="label"><i class="far fa-calendar-alt"></i> Meeting Date</v-flex>
                                <v-menu ref="menuFrom"
                                    :close-on-content-click="false" class="calander-icon"
                                    v-model="menuFrom" attach
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                    max-width="290px">
                                <v-text-field slot="activator"
                                              v-model="startDate"
                                              prepend-inner-icon="event"
                                              label="Meeting Date"
                                              data-qe-id="forum-meeting_date_start"
                                              :rules="fromDateRules"
                                              required
                                              readonly></v-text-field>
                                <v-date-picker ref="picker"
                                               v-model="startDate"
                                               :show-current="false"
                                               :min="new Date().toISOString().substr(0, 10)"
                                               @change="save"></v-date-picker>
                            </v-menu>
                            </v-flex>
                           
                        </v-layout>
                        <v-layout row wrap class="create-meeting__row">
                            <v-flex xs3>
                                <v-flex tag="label"><i class="far fa-clock"></i> Meeting Time</v-flex>
                            </v-flex>
                            <v-flex xs5>
                                <v-layout row wrap>
                                    <v-flex xs3>Start Time</v-flex>
                                    <v-flex xs9>
                                        <time-picker v-model="newMeeting.startTime" />
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs3>End Time</v-flex>
                                    <v-flex xs9>
                                        <time-picker v-model="newMeeting.endTime" />
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs3>Time Zone</v-flex>
                                    <v-flex xs9 pl-2>
                                        <v-select
                                            solo
                                            v-model="currentTimeZone"
                                            data-qe-id="forum-meeting_time-zone_select_dropdown"
                                            :items="getTimeZones"
                                            label="Select Your Time Zone"></v-select>
                                    </v-flex>
                                </v-layout>

                            </v-flex>

                            <v-flex xs4 text-xs-right>
                                <v-progress-circular
                                    :rotate="360"
                                    :size="150"
                                    :width="15"
                                    :value="100"
                                    color="ypo_blue">
                                    <strong>00:00 Hours</strong>
                                </v-progress-circular>
                            </v-flex>

                        </v-layout>
                        <v-layout row wrap class="create-meeting__row">
                            <v-flex xs3>
                                <v-flex tag="label"><i class="fas fa-map-marker-alt"></i> Meeting Location</v-flex>
                            </v-flex>
                            <forum-location></forum-location>
                        </v-layout>
                        <v-layout row wrap class="create-meeting__row">
                            <v-flex xs3>
                                <v-flex tag="label"><i class="fas fa-file-alt"></i> Notes</v-flex>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field outline single-line></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-flex class="note__text" xs6>YPO recommends 4 hours for a Standard Forum Meeting and 2 hours for a Virtual Forum Meeting
                        </v-flex>

                    </v-flex>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-layout row wrap pa-3>
                        <v-flex xs12 class="bottom-row text-xs-right">
                            <v-btn :disabled="isNext" class="primary_btn"
                                   data-qe-id="forum-meeting_next_btn"
                                   id="open_meeting_unitTest"
                                   @click="openMeetingExceriseDialog">Next</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            persistent
            v-model="meetingExceriseDialog"
            scrollable
            content-class="medium">
            <v-card class="meetings-popup meeting-excerise">
                <v-flex>
                    <v-card-title>20 Dec 18 Meeting Exercise</v-card-title>
                    <v-btn
                        flat
                        icon
                        data-qe-id="forum-meeting_second-create_btn"
                        @click="openCreateNewMeetingDialog()"
                        class="close-btn">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-flex>
                <v-card-text class="inner-scrollbar">
                    <v-flex class="">
                        <v-stepper v-model="e1" alt-labels>
                            <v-stepper-header>
                                <v-stepper-step :complete="e1 > 1" step="1">WELCOME</v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="e1 > 2" step="2">UPDATES</v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step :complete="e1 > 3" step="3">DEEPER DIVE</v-stepper-step>

                                <v-divider></v-divider>

                                <v-stepper-step step="4">CLOSING</v-stepper-step>
                            </v-stepper-header>

                            <v-stepper-items>
                                <v-stepper-content step="1">
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <v-flex class="left-panel">
                                                <v-expansion-panel expand>
                                                    <v-expansion-panel-content>
                                                        <div slot="header">Centering</div>
                                                        <v-card>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-card>
                                                    </v-expansion-panel-content>
                                                    <v-expansion-panel-content>
                                                        <div slot="header">Reconnection</div>
                                                        <v-card>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-card>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-flex>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-flex class="right-panel">
                                                <v-layout row wrap class="details-list">
                                                    <v-flex xs9>
                                                        <strong>Confidentiality Reminder</strong>
                                                        <em>Required</em>
                                                    </v-flex>
                                                    <v-flex xs3 class="time_block text-right">
                                                        <i class="far fa-clock"></i> 01 min
                                                    </v-flex>

                                                    <v-flex class="delete_btn"><i class="fas fa-trash"></i>Delete</v-flex>
                                                </v-layout>

                                                <v-layout row wrap class="details-list">
                                                    <v-flex xs9>
                                                        <strong>Confidentiality Reminder</strong>
                                                        <em>Required</em>
                                                    </v-flex>
                                                    <v-flex xs3 class="time_block text-right">
                                                        <i class="far fa-clock"></i> 01 min
                                                    </v-flex>

                                                    <v-flex class="delete_btn"><i class="fas fa-trash"></i>Delete</v-flex>
                                                </v-layout>

                                                <v-layout row wrap class="details-list">
                                                    <v-flex xs9>
                                                        <strong>Confidentiality Reminder</strong>
                                                        <em>Required</em>
                                                    </v-flex>
                                                    <v-flex xs3 class="time_block text-right">
                                                        <i class="far fa-clock"></i> 01 min
                                                    </v-flex>

                                                    <v-flex class="delete_btn"><i class="fas fa-trash"></i>Delete</v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex>
                                                <v-btn class="primary_btn">Save</v-btn>
                                                <v-btn class="primary_btn">Add Break</v-btn>
                                            </v-flex>

                                        </v-flex>
                                    </v-layout>

                                </v-stepper-content>

                                <v-stepper-content step="2">
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <v-flex class="left-panel">
                                                <v-expansion-panel expand>
                                                    <v-expansion-panel-content>
                                                        <div slot="header">Centering</div>
                                                        <v-card>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-card>
                                                    </v-expansion-panel-content>
                                                    <v-expansion-panel-content>
                                                        <div slot="header">Reconnection</div>
                                                        <v-card>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-card>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-flex>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-flex class="right-panel">
                                                <v-layout row wrap class="details-list">
                                                    <v-flex xs9>
                                                        <strong>Confidentiality Reminder</strong>
                                                        <em>Required</em>
                                                    </v-flex>
                                                    <v-flex xs3 class="time_block text-right">
                                                        <i class="far fa-clock"></i> 01 min
                                                    </v-flex>

                                                    <v-flex class="delete_btn"><i class="fas fa-trash"></i>Delete</v-flex>
                                                </v-layout>

                                                <v-layout row wrap class="details-list">
                                                    <v-flex xs9>
                                                        <strong>Confidentiality Reminder</strong>
                                                        <em>Required</em>
                                                    </v-flex>
                                                    <v-flex xs3 class="time_block text-right">
                                                        <i class="far fa-clock"></i> 01 min
                                                    </v-flex>

                                                    <v-flex class="delete_btn"><i class="fas fa-trash"></i>Delete</v-flex>
                                                </v-layout>

                                                <v-layout row wrap class="details-list">
                                                    <v-flex xs9>
                                                        <strong>Confidentiality Reminder</strong>
                                                        <em>Required</em>
                                                    </v-flex>
                                                    <v-flex xs3 class="time_block text-right">
                                                        <i class="far fa-clock"></i> 01 min
                                                    </v-flex>

                                                    <v-flex class="delete_btn"><i class="fas fa-trash"></i>Delete</v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex>
                                                <v-btn class="primary_btn">Save</v-btn>
                                                <v-btn class="primary_btn">Add Break</v-btn>
                                            </v-flex>

                                        </v-flex>
                                    </v-layout>
                                </v-stepper-content>

                                <v-stepper-content step="3">
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <v-flex class="left-panel">
                                                <v-expansion-panel expand>
                                                    <v-expansion-panel-content>
                                                        <div slot="header">Centering</div>
                                                        <v-card>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-card>
                                                    </v-expansion-panel-content>
                                                    <v-expansion-panel-content>
                                                        <div slot="header">Reconnection</div>
                                                        <v-card>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-card>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-flex>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-flex class="right-panel">
                                                <v-layout row wrap class="details-list">
                                                    <v-flex xs9>
                                                        <strong>Confidentiality Reminder</strong>
                                                        <em>Required</em>
                                                    </v-flex>
                                                    <v-flex xs3 class="time_block text-right">
                                                        <i class="far fa-clock"></i> 01 min
                                                    </v-flex>

                                                    <v-flex class="delete_btn"><i class="fas fa-trash"></i>Delete</v-flex>
                                                </v-layout>

                                                <v-layout row wrap class="details-list">
                                                    <v-flex xs9>
                                                        <strong>Confidentiality Reminder</strong>
                                                        <em>Required</em>
                                                    </v-flex>
                                                    <v-flex xs3 class="time_block text-right">
                                                        <i class="far fa-clock"></i> 01 min
                                                    </v-flex>

                                                    <v-flex class="delete_btn"><i class="fas fa-trash"></i>Delete</v-flex>
                                                </v-layout>

                                                <v-layout row wrap class="details-list">
                                                    <v-flex xs9>
                                                        <strong>Confidentiality Reminder</strong>
                                                        <em>Required</em>
                                                    </v-flex>
                                                    <v-flex xs3 class="time_block text-right">
                                                        <i class="far fa-clock"></i> 01 min
                                                    </v-flex>

                                                    <v-flex class="delete_btn"><i class="fas fa-trash"></i>Delete</v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex>
                                                <v-btn class="primary_btn">Save</v-btn>
                                                <v-btn class="primary_btn">Add Break</v-btn>
                                            </v-flex>

                                        </v-flex>
                                    </v-layout>
                                </v-stepper-content>

                                <v-stepper-content step="4">
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <v-flex class="left-panel">
                                                <v-expansion-panel expand>
                                                    <v-expansion-panel-content>
                                                        <div slot="header">Centering</div>
                                                        <v-card>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-card>
                                                    </v-expansion-panel-content>
                                                    <v-expansion-panel-content>
                                                        <div slot="header">Reconnection</div>
                                                        <v-card>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                            <v-flex class="add-item">
                                                                <strong>Heading</strong>
                                                                <small>Exercise description comes here</small>
                                                                <v-btn flat icon>
                                                                    <v-icon class="fas fa-plus"></v-icon>
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-card>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                            </v-flex>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-flex class="right-panel">
                                                <v-layout row wrap class="details-list">
                                                    <v-flex xs9>
                                                        <strong>Confidentiality Reminder</strong>
                                                        <em>Required</em>
                                                    </v-flex>
                                                    <v-flex xs3 class="time_block text-right">
                                                        <i class="far fa-clock"></i> 01 min
                                                    </v-flex>

                                                    <v-flex class="delete_btn"><i class="fas fa-trash"></i>Delete</v-flex>
                                                </v-layout>

                                                <v-layout row wrap class="details-list">
                                                    <v-flex xs9>
                                                        <strong>Confidentiality Reminder</strong>
                                                        <em>Required</em>
                                                    </v-flex>
                                                    <v-flex xs3 class="time_block text-right">
                                                        <i class="far fa-clock"></i> 01 min
                                                    </v-flex>

                                                    <v-flex class="delete_btn"><i class="fas fa-trash"></i>Delete</v-flex>
                                                </v-layout>

                                                <v-layout row wrap class="details-list">
                                                    <v-flex xs9>
                                                        <strong>Confidentiality Reminder</strong>
                                                        <em>Required</em>
                                                    </v-flex>
                                                    <v-flex xs3 class="time_block text-right">
                                                        <i class="far fa-clock"></i> 01 min
                                                    </v-flex>

                                                    <v-flex class="delete_btn"><i class="fas fa-trash"></i>Delete</v-flex>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex>
                                                <v-btn class="primary_btn">Save</v-btn>
                                                <v-btn class="primary_btn">Add Break</v-btn>
                                            </v-flex>

                                        </v-flex>
                                    </v-layout>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>

                    </v-flex>

                </v-card-text>

                <v-card-actions>
                    <v-layout row wrap pa-3>
                        <v-flex xs6 class="">
                            <v-btn
                                :disabled="e1 === 1"
                                outline
                                class="primary_btn"
                                data-qe-id="forum_meeting-back_btn"
                                @click="--e1">Back</v-btn>
                        </v-flex>
                        <v-flex xs6 class="text-xs-right">
                            <v-btn class="primary_btn" :disabled="e1 === 4"
                                   data-qe-id="forum_meeting-next_btn"
                                   @click="++e1">Next</v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
    import TimePicker from "../TimePicker/TimePicker.vue";
    import { mapActions, mapGetters } from 'vuex';
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from '../../store/storeActions.constant';
    import ForumLocation from '../ForumPage/ForumLocation';
    import moment from 'moment-timezone';
    import { eventDirectoryPageConstant } from "../EventDirectoryPage/eventDirectoryPage.constants";

    export default {
        name: "ForumMeetings",
        data: () => {
            return {
                eventDirectoryPageConstant,
                myMeetingsDialog: false,
                createNewMeetingDialog: false,
                newMeeting: {
                    selectedForum: '',
                    startTime: { hours: '00', minutes: '00', ampm: 'PM' },
                    endTime: { hours: '00', minutes: '00', ampm: 'PM' },
                },
                meetingExceriseDialog: false,
                e1: 1,
                selectedTimeZone: "",
                startDate: null,
                fromDateRules: [
                    v => !!v || this.eventDirectoryPageConstant.errors.FROM_DATE_REQUIRED,
                ],
                isSActive: false,
                isSRctive: false,
                isNext: false,
                menuFrom: false,
                isActive: false,
            };
        },
        components: {
            TimePicker,
            ForumLocation,
        },
        created() {
            this.getForumMeetingsList();
        },

        methods: {
            ...mapActions({
                getForumMeetingsList: `forumMeetings/${storeAction.getForumMeetingsView}`,
            }),
            closeAllDialogs() {
                this.myMeetingsDialog = false;
                this.createNewMeetingDialog = false;
                this.meetingExceriseDialog = false;
            },
            openMyMeetingsDialog() {
                this.myMeetingsDialog = true;
                this.createNewMeetingDialog = false;
                this.meetingExceriseDialog = false;
            },
            openCreateNewMeetingDialog() {
                this.myMeetingsDialog = false;
                this.createNewMeetingDialog = true;
                this.meetingExceriseDialog = false;
            },
            openMeetingExceriseDialog() {
                alert(this.newMeeting.selectedForum);
                // if (this.newMeeting.selectedForum) {

                // }
                if (this.newMeeting.startTime.hours < this.newMeeting.endTime.hours) {
                    this.isNext = true;
                    this.myMeetingsDialog = false;
                    this.createNewMeetingDialog = false;
                    this.meetingExceriseDialog = true;
                } else {
                    alert('Error in Time selection');
                }
            },
            save() {
                if (this.dateFrom && this.dateTo && this.dateTo > this.dateFrom) {
                    const fromDate = this.ribbonItemFromApi.filters.find((item) => {
                        if (item.label === this.datesRibbonFilters[0].label) {
                            return true;
                        }
                        return false;
                    });
                    const toDate = this.ribbonItemFromApi.filters.find((item) => {
                        if (item.label === this.datesRibbonFilters[1].label) {
                            return true;
                        }
                        return false;
                    });
                    const dateRange = this.localFilterState.find(item => item.filterKey === this.eventDirectoryPageConstant.constant.dateRangeButtonKey);
                    this.localFilterState = [];
                    this.localFilterState.push({ ...fromDate, filterValue: new Date(this.dateFrom) });
                    this.localFilterState.push({ ...toDate, filterValue: new Date(this.dateTo) });
                    this.localFilterState.push(dateRange);
                }
            },
        },

        computed: {
            ...mapGetters({
                usersCommunitiesList: `chapter/${storeGetters.usersCommunitiesList}`,
                forumMeetings: `forumMeetings/${storeGetters.forumMeetings}`,
            }),
            getTimeZones() {
                const names = moment.tz.names();
                const arr = [];
                const timeZones = names.map(name => ({
                    tzName: name,
                    tzPresentationName: moment.tz(name).format('Z'),
                }));
                arr.push(...timeZones);

                arr.sort((a, b) => {
                    if (a.tzPresentationName === b.tzPresentationName) {
                        if (a.tzName === 'UTC') {
                            return -1;
                        }
                        // eslint-disable-next-line no-nested-ternary
                        return a.tzName === b.tzName ? 0 : (a.tzName > b.tzName ? 1 : -1);
                    }
                    const afc = a.tzPresentationName.charAt(0);
                    const bfc = b.tzPresentationName.charAt(0);
                    if (afc === '-') {
                        if (bfc === '+') {
                            return -1;
                        }
                        return a.tzPresentationName > b.tzPresentationName ? -1 : 1;
                    }
                    if (bfc === '-') {
                        return 1;
                    }
                    return a.tzPresentationName > b.tzPresentationName ? 1 : -1;
                });
                arr.forEach((element) => {
                    element.tzPresentationName = `${element.tzName} (GMT ${element.tzPresentationName})`;
                });
                const timeZoneData = arr.map(i => i.tzPresentationName);

                return timeZoneData;
            },
            currentTimeZone: {
                get() {
                    return this.getTimeZones.includes(moment.tz.guess());
                },
                set(val) {
                    this.selectedTimeZone = val;
                },
            },
            forumsList() {
                let forumList = [];
                if (this.usersCommunitiesList) {
                    // forumList.push({ id: 0, name: 'Select Forum' })
                    forumList = this.usersCommunitiesList.filter(item => item.communityType === 'Forum')
                        .map((i) => {
                            return { id: i.communityId, name: i.name };
                        });
                    forumList.unshift({ id: 0, name: 'Select Forum' });
                }
                return forumList;
            },

        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .nav-menu {
        position: sticky;
        top: 68px;
        z-index: 7;
        margin-bottom: 20px;
        box-shadow: 0 2px 4px 0 rgba($black, 0.5);
    }

    .nav_links {
        border-radius: 4px 4px 0 0;
        background-color: $ypo-blue;
        transition: 0.5s;

        a {
            color: rgba($ypo-dark-background-gray, 1);
            text-decoration: none;
            font-size: 14px;
            font-weight: 300;
            line-height: 16px;
            display: inline-block;
            position: relative;

            transition: 0.3s;
            padding: 18px 15px;

            &.router-link-active {
                color: $white;
                background: rgba($ypo-title-blue, 0.2);

                &:after {
                    width: 100%;
                }

                &.no-link {
                    &:after {
                        width: 0;
                    }
                }
            }

            &:hover {
                color: $white;
                background: rgba($ypo-title-blue, 0.2);
            }

            &:last-child {
                margin-right: 0;

                &:before {
                    display: none;
                }
            }

            &:before {
                content: "";
                position: absolute;
                right: 0px;
                top: 0px;

                width: 1px;
                height: 100%;
                background: rgba($white, 0.05);
            }

            &:after {
                content: "";
                width: 0;
                background: $ypo_gold;
                height: 3px;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                transition: 0.3s;
            }

            &.submenu-link {
                &::after {
                    opacity: 0;
                }
            }
        }
    }

    .quick_links {
        margin: 10px 15px;

        .v-divider {
            border-color: rgba($ypo-gray, 0.4);
        }

        .v-icon {
            color: $ypo-blue;
        }

        .list_items {
            cursor: pointer;

            .v-list__tile {
                height: inherit !important;
            }

            .v-list__tile__title {
                font-size: 14px;
                color: $ypo_blue;
            }

            .v-list__tile__action {
                min-width: inherit;
                margin-right: 10px;

                .v-icon {
                    font-size: 20px;
                }
            }
        }
    }

    .recom_member {
        height: auto;
        padding: 15px 5px 5px 5px;
        align-items: stretch;

        .v-list__tile__action {
            padding-top: 30px;
        }

        .v-list__tile__title {
            color: $ypo-cta;
            font-size: 16px;
            font-weight: 500;
        }

        .v-list__tile__sub-title {
            font-size: 12px;
            color: $ypo-gray;
        }

        .desc {
            font-size: 12px;
            color: $ypo-gray;
            display: block;
            margin-top: 10px;
        }

        .like_btns .unlike_btn .v-icon {
            color: $ypo-dark-gray;
            opacity: 0.5;
            cursor: pointer;

            &:hover {
                opacity: 1;
            }
        }

        .like_btn .v-icon {
            color: $ypo-cta;
            opacity: 0.7;
            padding-left: 12px;
            position: relative;
            top: -6px;
            cursor: pointer;

            &:hover {
                opacity: 1;
            }

            &:before {
                content: "";
                position: absolute;
                left: 4px;
                top: 7px;
                width: 2px;
                background: $ypo-gray;
                height: 15px;
            }
        }
    }

    .sub-menu {
        background: rgb(32, 65, 100);
        padding-left: 10px;
        opacity: 0;
        height: 0;
        overflow: hidden;

        &.is-collapsed {
            opacity: 1;
            height: auto;
        }

        a {
            color: $white;
            opacity: 0.5;
            margin: 0 10px;
            text-decoration: none;
            font-size: 12px;
            padding: 13px 0px;
            display: inline-block;
            position: relative;

            &:hover {
                opacity: 1;
            }

            &.router-link-active {
                opacity: 1;

                &:after {
                    width: 100%;
                }
            }

            &:after {
                content: "";
                width: 0;
                background: $ypo_gold;
                height: 3px;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                transition: 0.3s;
            }
        }
    }

    .about_section {
        box-shadow: none;

        .v-icon {
            font-size: 19px;
        }

        p {
            padding: 0 20px;
            margin-top: 15px;
        }

        .v-expansion-panel__container {
            border-radius: 4px;
        }

        .v-expansion-panel__header {
            padding: 0;
            min-height: inherit;

            h2 {
                border-bottom: none;
                margin: 0;
                padding: 0;
            }
        }

        .v-list__tile__title {
            color: $ypo-blue-dark-background;
            font-family: Raleway;
            font-size: 20px;
            letter-spacing: 0.17px;
            line-height: 29px;
            margin-bottom: 5px;
        }

        .v-list__tile__sub-title {
            color: $black;
            font-family: Raleway;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0.46px;
            line-height: 16px;
        }
    }

    .message_about {
        background: $ypo-extra-light-gray;
        border: 1px solid $ypo-medium-gray;
        margin: 10px;
        border-radius: 4px;

        h2 {
            font-size: 20px;
        }
    }

    .about_more {
        border: 1px solid $ypo-medium-gray;
        margin: 10px;
        border-radius: 4px;
        background-color: rgba($ypo-gold, 0.1);
    }

    .ypo_international {
        padding: 8px;

        .v-card {
            margin: 5px;
            background: $ypo-extra-light-gray;
        }

        .v-card__title {
            padding: 5px 0;
            text-align: center;
            display: block;
            font-size: 12px;
            color: $ypo_blue;
        }
    }

    .files-media {
        padding: 15px 0px;
        border-bottom: 1px solid $ypo-medium-gray;
        margin: 0 15px;

        strong {
            font-weight: 400;
            color: $ypo-dark-background-gray;
            font-family: "Noto Sans";
            font-size: 16px;
            letter-spacing: 0.25px;
            line-height: 18px;
        }

        small {
            display: block;
            color: $ypo-gray-text;
            font-size: 10px;
            letter-spacing: 0.3px;
            line-height: 10px;
            margin-top: 10px;
        }

        i {
            font-size: 26px;
            color: $ypo_blue;
        }

        &__icon {
            text-align: center;

            small {
                margin-top: 3px;
            }
        }
    }

    .forum-quicklinks {
        margin-top: 10px;

        .flex {
            border-bottom: 1px solid $ypo-tile-border;
            margin: 0 20px;

            a {
                color: $ypo-cta;
                font-family: "Noto Sans";
                font-size: 14px;
                line-height: 18px;
                text-decoration: none;
                display: inline-block;
                padding: 15px 0px;
                transition: 0.3s;

                &:hover {
                    color: $ypo_blue;
                }
            }
        }
    }

    .meeting-tools {
        &__links {
            cursor: pointer;
            text-align: center;
            width: auto;
            display: inline-block;
            color: $ypo-dark-background-gray;
            padding: 30px 30px;
            transition: 0.3s;

            &:hover {
                color: $ypo_blue;
            }

            i {
                display: block;
                font-size: 36px;
            }

            strong {
                font-weight: 500;
                margin-top: 5px;
                display: block;
            }
        }
    }

    .meetings-popup {
        background: $white;

        .close-btn {
            position: absolute;
            right: 0;
            top: 0;
            color: $ypo-blue;

            i {
                font-size: 20px;
                font-weight: 600;
            }
        }

        .v-card__text {
            padding: 0px;
        }

        &__moreitems {
            position: relative;

            &:before {
                content: "";
                height: 100%;
                position: absolute;
                border-left: 1px dashed $ypo-dark-background-gray;
                left: 23px;
            }
        }

        .v-card__title {
            border-radius: 4px 4px 0 0;
            background-color: rgba($ypo_blue, 0.15);
            padding: 15px 10px 15px 50px;
            font-weight: 300;
            font-size: 24px;
            margin-bottom: 20px;
            color: $ypo_blue;
        }

        .date {
            color: $ypo-gold;
            font-size: 16px;
            font-weight: bold;
            line-height: 22px;
            padding: 0px 0 10px 15px;

            i {
                font-size: 20px;
                color: $ypo_blue;
                margin-right: 10px;
                background: $white;
                position: relative;
                z-index: 1;
            }
        }

        .desc {
            position: relative;
            padding: 15px 10px 15px 60px;
            cursor: pointer;
            margin-bottom: 20px;
            transition: all 0.4s ease;

            &:after {
                content: "";
                width: 90%;
                left: 7%;
                bottom: 0;
                height: 2px;
                background: rgba($ypo-blue-secondary, 0.05);
                position: absolute;
            }

            &+.desc {
                margin-top: -20px;
            }

            strong {
                color: $ypo_blue;
                font-size: 16px;
                font-weight: bold;
                line-height: 22px;
                display: block;
                margin-bottom: 10px;
            }

            span {
                color: $black;
                font-family: "Noto Sans";
                font-size: 12px;
                letter-spacing: -0.15px;
                line-height: 22px;
                border-right: 1px solid $ypo-medium-gray;
                padding-right: 15px;
                margin-right: 15px;

                i {
                    color: $ypo-dark-background-gray;
                    margin-right: 5px;
                }
            }

            small {
                color: rgba($black, 0.5);
                font-size: 12px;
                letter-spacing: -0.15px;
                line-height: 22px;

                i {
                    color: $ypo-dark-background-gray;
                    margin-right: 5px;
                }
            }

            .more-info {
                position: absolute;
                right: 10px;
                top: 25px;
                text-align: center;
                color: $ypo-dark-background-gray;
                padding: 0 20px;
                transition: all 0.2s ease;

                i {
                    display: block;
                }

                small {
                    color: $ypo-dark-background-gray;
                    text-transform: uppercase;
                    font-size: 10px;
                }
            }

            &:hover {
                background: rgba($ypo-blue-secondary, 0.05);

                .more-info {
                    opacity: 0;
                    visibility: hidden;
                }

                .desc__actions {
                    opacity: 1;
                    visibility: visible;
                }
            }

            &__actions {
                position: absolute;
                right: 20px;
                top: 25px;
                z-index: 1;
                opacity: 0;
                visibility: hidden;
                transition: all 0.6s ease;

                em {
                    color: $ypo-gray-text;
                    font-size: 10px;
                    font-style: normal;
                    line-height: 14px;
                    text-align: center;
                    display: inline-block;
                    margin: 0 10px;
                    cursor: pointer;

                    i {
                        display: block;
                        font-size: 19px;

                        &.fa-share {
                            color: $ypo-blue-secondary;
                        }

                        &.fa-times-circle {
                            color: $ypo-red;
                        }
                    }
                }
            }
        }
    }

    .create-meeting {
        padding: 20px 50px;

        &__row {
            margin-bottom: 30px;

            label {
                color: $black;
                cursor: text;
                font-size: 14px;
                font-weight: 600;
                line-height: 20px;

                i {
                    color: $ypo-dark-background-gray;
                    font-size: 16px;
                    margin-right: 5px;
                }
            }

            .v-progress-circular {
                strong {
                    text-align: center;
                    display: block;
                    font-size: 20px;
                    color: $ypo-gray-text;
                    text-transform: uppercase;
                    line-height: normal;
                }
            }
        }

        &__btn {
            box-shadow: 0 2px 4px 0 rgba($black, 0.2);
            border: 1px solid $ypo-light-gray-background;
            border-radius: 4px;
            display: inline-block;
            margin: 0 30px 0 0px;
            text-align: center;
            color: $ypo-tile-border;
            transition: 0.3s;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: -0.15px;
            line-height: 18px;
            padding: 15px 10px;
            cursor: pointer;
            width: 110px;
            transition: 0.2s;
            vertical-align: top;
            min-height: 110px;

            &:hover {
                background-color: $ypo-blue-secondary;
                color: $white;
                box-shadow: 0 10px 15px 0 rgba($black, 0.2);
                border-color: $ypo-blue-secondary;
            }

            i {
                display: block;
                font-size: 30px;
                margin-bottom: 10px;
            }

            strong {
                font-weight: 500;
                text-transform: uppercase;
            }
        }

        .note__text {
            color: $ypo-open-blue-gray;
            font-size: 14px;
            line-height: 20px;
            padding-left: 20px;
        }

        &__bg-active {
            background-color: $ypo-blue-secondary;
            color: $white;
        }
    }

    .meeting-excerise {
        .left-panel {
            border: 1px solid $ypo-open-blue-gray;
            border-radius: 4px;
            background-color: rgba($ypo-gray, 0.1);
            min-height: 350px;
            margin-right: 10px;

            .add-item {
                border-bottom: 1px solid $ypo-open-blue-gray;
                padding: 7px 20px;
                position: relative;
                transition: 0.4s all ease;
                cursor: pointer;

                &:hover {
                    background: rgba($ypo-blue-secondary, 0.05);

                    .v-btn {
                        opacity: 1;
                    }
                }

                small {
                    display: block;
                    font-size: 12px;
                }

                strong {
                    color: $ypo_blue;
                    display: block;
                }

                .v-btn {
                    position: absolute;
                    right: 20px;
                    z-index: 1;
                    top: 5px;
                    opacity: 0;
                    transition: 0.4s all ease;

                    .v-icon {
                        font-size: 14px;
                        color: $ypo_blue;
                    }
                }
            }
        }

        .right-panel {
            border: 1px solid $ypo-open-blue-gray;
            border-radius: 4px;
            background-color: rgba($ypo-gray, 0.1);
            min-height: 350px;
            margin-left: 10px;

            .details-list {
                border-bottom: 1px solid $ypo-open-blue-gray;
                padding: 7px 20px;
                position: relative;
                transition: 0.4s all ease;
                cursor: pointer;
                background: $white;
                color: $ypo-dark-background-gray;
                font-size: 12px;
                align-items: center;

                strong {
                    color: $ypo_blue;
                    display: block;
                    font-size: 14px;
                }

                em {
                    display: block;
                    color: $ypo-dark-background-gray;
                    font-size: 12px;
                }

                .delete_btn {
                    opacity: 0;
                    text-align: center;
                    color: $ypo_blue;
                    position: absolute;
                    right: 28px;
                    top: 12px;

                    i {
                        display: block;
                        font-size: 14px;
                    }
                }

                &:hover {
                    background: rgba($ypo-blue-secondary, 0.05);

                    .delete_btn {
                        opacity: 1;
                    }

                    .time_block {
                        opacity: 0;
                    }
                }
            }
        }

        .v-stepper__header {
            box-shadow: none;
            background: $ypo_blue;
            padding: 0 150px;
        }

        .v-card__title {
            margin-bottom: 0px;
        }
    }
</style><style lang="scss">
    @import "../../common/styles/_colors.scss";

    .meetings-popup {
        .v-text-field.v-text-field--enclosed .v-input__slot {
            min-height: 40px;
            border: 1px solid $ypo-tile-border;
            margin-bottom: 0;
            box-shadow: none;
            border-radius: 4px;

            &:hover {
                border: 1px solid $ypo-tile-border;
            }
        }

        .v-input input {
            text-align: center;
            margin-top: 4px;
        }

        .v-text-field.v-text-field--enclosed .v-text-field__details {
            margin-bottom: 0;
        }
    }

    .meeting-excerise {
        .v-stepper__step__step {
            background: $white !important;
            width: 18px;
            height: 18px;
            min-width: 18px;
        }

        .v-stepper__step--complete {
            .v-stepper__step__step {
                background: $ypo_gold !important;

                .v-icon {
                    font-size: 12px;
                }
            }
        }

        .v-stepper__step--active {
            .v-stepper__step__step {
                border: 2px solid $ypo_gold !important;
            }
        }

        .v-stepper__label {
            color: $white !important;
            text-transform: uppercase;
            font-size: 12px;
        }

        .v-stepper__header .v-divider {
            border-color: rgba($white, 0.5) !important;
            margin: 35px -77px 0;
        }

        .v-expansion-panel__container .v-expansion-panel__header {
            border-bottom: 1px solid $ypo-open-blue-gray;
            background: $ypo-open-blue-gray;
            color: $ypo_blue;
            font-weight: 600;
            font-size: 18px;
            padding: 10px 15px;
        }
    }
</style>
